<template>
    <div >
        <div  v-if="user.token != ''" class="mb-10" style="margin-bottom: 40px;" id="mainHeader3">
            <header>
            <div class="sticky-wrapper" style="height: 20px;">
                <div class="sticky-nav stuck">
                    <a id="mobile-nav" class="menu-nav" href="#menu-nav"></a>

                    <div id="logo">
                        <div class="float-left" @click="change_view('lobby')" style="cursor:pointer">
                            <img @click="render_home" v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo"
                                :width="skin.header_desktop.logo_width" alt=""
                                style="max-width: 170px;max-height: 45px;">
                        </div>
                    </div>

                    <nav id="menu">
                        <ul id="menu-nav">
                            <li>Usuario: <span class="color-text" onmouseover="this.style.cursor='pointer';"
                                    @click="goTo()"
                                    style="cursor: pointer;">{{ user.user_data.data ? user.user_data.data.user_name : '' }}&nbsp;<span
                                        class="color-text font-icon-cogs"><i class="fa fa-cogs" aria-hidden="true"></i></span></span></li>
                            <li v-if="skin.header_desktop.balance">Fichas: <span class="color-text" id="Saldo"><strong><b>{{ user.user_data.data ? new Intl.NumberFormat("de-DE",{minimumFractionDigits: skin.qBet_config.decimalsQty,maximumFractionDigits: skin.qBet_config.decimalsQty}).format(balance.saldo) : 0 }}</b></strong></span></li>
                            <li>Puesto: <span class="color-text">Sin Ranking</span></li>
                            <li>
                                <span :style="skin.header_desktop.nav_bar_text+(this.message_recived?'color:red;':'')" @click="openSupportModalJivo()" >
                                    <i class="fa-regular fa-comment-dots"></i>
                                </span>
                            </li>
                            <li><a class="external" href="#" v-if="homeButton" @click="render_home" >HOME</a></li>
                            <li><a class="external" href="#" v-if="skin.logout" @click="logout" >Salir</a></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
        </div>

        <misDatos
            v-if="mis_datos"
            v-bind:skin="skin"
            v-bind:language="language"
            v-bind:translation="translation"
        />
        
        <login3 v-if="user.token == ''" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" id="mainHeader3" />
    </div>

</template>

<script>
import myAccountZeus from "./my_account.vue";
import login3 from "./login.vue";
import register from './register.vue';
import languageSelector from './language.vue';
import changePassword from "./changePassword.vue";
import misDatos from "./mis_datos.vue";
export default {
    name: "mainHeader3",
    props: ['skin', 'language', 'translation'],
    data() {
        return {
            currentView: '',
            activeColor: this.skin.prematch_all_odds.hover_fondo,
            activeTab: 'home-tab',
            showBalance: false,
            userDataLoaded: false,
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
            newMessage: false,
            supportTickets: []
        }
    },
    components: {
        myAccountZeus,
        login3,
        register,
        languageSelector,
        changePassword,
        misDatos
    },
    methods: {
        render_home() {
             if (this.actualRoute=='Home') {
                const iframeContainer = document.querySelector('.holds-the-iframe');
                if (iframeContainer) {
                    // Enviar mensaje al iframe para que se recargue
                    const iframe = iframeContainer.querySelector('iframe');
                    if (iframe) {
                        iframe.contentWindow.postMessage({ action: 'reloadIframe' }, '*');
                        this.$store.dispatch("setHomeButton", false);
                        this.$store.dispatch("setMisdatos", false);
                    } else {
                            // console.error('No se encontró un iframe dentro del contenedor con la clase "holds-the-iframe".');
                    }
                } else {
                    // console.error('No se encontró el contenedor con la clase "holds-the-iframe".');
                    this.$store.dispatch("setMisdatos", false);
                    this.$store.dispatch("setHomeButton", false);
                }                
            } else {
                router.push({name:"Home"}).catch(() => {})
                this.$store.dispatch("setHomeButton", false);
                this.$store.dispatch("setMisdatos", false);
            }
        },
        openSupportModalJivo() {
            const jivoElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoElement) {
                    jivoElement.style.display = 'none';
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoElement) {
                    jivoElement.style.display = 'block';
                    jivo_api.open()
                }
                setTimeout(() => {
                    jivo_api.open()
                }, 500);
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);

            }
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        // login() {
        //     document.getElementById('login_btn').click();
        // },
        register() {
            document.getElementById('register_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$store.dispatch("setMisdatos", false);
            this.$root.$emit('forceRender');
        },
        my_account() {
            window.parent.postMessage(
                {
                    action: 'openSlider',
                    tab: 'recentBets'
                },
                '*'
            );
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        goTo() {
            this.$store.dispatch("setMisdatos", true);
            this.$store.dispatch("setHomeButton", true);
        },
        setMenuCenter() {
            const menuContainerWidth = document.getElementById('navbarText')?.offsetWidth;
            const items = document.getElementsByClassName('nav-item');
            const menuListWidth = [...items].map(item => item.offsetWidth).reduce((acumulador, valorActual) => acumulador + valorActual, 0);
            const calculatedMargin = (menuContainerWidth / 2) - (menuListWidth / 2);
            const dummy = document.getElementById('marginDummy');
            if (dummy) {
                dummy.style.width = calculatedMargin + 'px'
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        }
    },
    computed: {
        active_item() {
            return {
                "--background": this.$props.skin.header_desktop.nav_bar_item_hover_background,
                "--color": this.$props.skin.header_desktop.nav_bar_item_hover_color,
                "--border": this.$props.skin.header_desktop.nav_bar_item_hover_border,
            }
        },
        activeBarStyle() {
            // console.log(this.skin.header_desktop.servicios)
            return {
                backgroundColor: '1c1c1c',
                color: "#fff",
                borderBottom: `2px solid ${this.skin.header_desktop.nav_bar_text}`
            };
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        mis_datos() {
            return this.$store.getters["getMisdatos"]
        },
        actualRoute() {
            return this.$store.getters["getActualRoute"]
        },
        homeButton() {
            return this.$store.getters["getHomeButton"]
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        header_productsQty() {
            let products = [this.$props.skin.poker, this.$props.skin.prematch, this.$props.skin.casinoN, this.$props.skin.casino_live, this.$props.skin.hipicas, this.$props.skin.login, this.$props.skin.logout];
            return products.filter(x => x == true).length + 1;
        }
    },
    mounted() {
        // console.log(this.skin.prematch_all_odds.hover_fondo)
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader3").offsetHeight + 5);
        this.setMenuCenter()
        window.addEventListener('resize', () => { this.setMenuCenter(); });
        // this.login()
    },
    watch: {
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    created() {
        const self = this;
        let balanceRequestTime = 8000;
        var saldo_request = setInterval(function () {
            try {
                if (self.user.user_data.data && self.user.token != '') {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId:self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                } else {
                    clearInterval(saldo_request);
                }
            } catch (error) {
                this.$store.dispatch('logOut');
                clearInterval(saldo_request);
            }
        }, balanceRequestTime);
        // background: url(../img/menu-mobile.png) 0 0 no-repeat;
    }
}
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300&display=swap');

header {
    width: 100%;
    z-index: 99;
    color: #7F8289;
    font-weight: 300;
    font-size: 16px;
    font-family: 'Titillium Web', sans-serif;
    line-height: 28px;
}

header .sticky-nav {
    position: relative;
    width: 100%;
    height: 60px;
    background: #26292e;
    z-index: 1001;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
}

header .sticky-nav.stuck {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001;
}

header #logo {
    color: #ffffff;
    float: left;
    padding: 15px 0;
    margin-left: 20px;
}

header #logo a {
    width: 260px;
    height: 30px;
    text-indent: -9999px;
    display: block;
    opacity: 1;
    transition: opacity 0.25s ease-in-out;
}

a {
    color: #00b7ff;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.1s linear;
}

header #logo a:hover {
    opacity: 0.65;
}

nav#menu {
    float: right;
    margin-right: 20px;
}

nav#menu #menu-nav {
    margin: 0;
    padding: 0;
}

nav#menu #menu-nav li {
    list-style: none;
    display: inline-block;
    margin-left: 50px;
}

nav#menu #menu-nav li:first-child {
    margin-left: 0;
}

nav#menu #menu-nav li a {
    color: #ffffff;
    font-size: 16px;
    font-weight: 300;
    line-height: 60px;
    display: block;
    text-transform: uppercase;
}

nav#menu #menu-nav li.current a,
nav#menu #menu-nav li a:hover,
nav#menu #menu-nav li .color-text {
    color: #00b7ff;
}

nav#menu #menu-nav li .color-text {
    font-size: 16px;
    font-weight: 300;
    line-height: 60px;
}
</style>